import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import Card from '../../components/CoPayCard';
import Footnotes from '../../components/Footnotes';
import CallToAction from '../../components/CallToAction';
import UnexpectedError from '../../components/UnexpectedError';

class Finish extends Component {
  componentWillUnmount () {
    this.props.clearForm();
  }

  render () {
    let content;

    switch (this.props.code) {
      case 'success':
        content = (() => {
          return (
            <div className="success">
              <Header as="h1">
                Thank you
              </Header>
              <Header.Subheader as="p">
                You have successfully retrieved your patient’s <span className="nowrap-txt">Takeda Oncology</span> Co-Pay Card information.
              </Header.Subheader>
              <p className="note">Your patient will receive a letter in the mail that contains his or her Takeda Oncology Co-Pay Card replacement.*</p>
              <p><b>Below is an image of the card he or she will receive. Please print a copy of the card below, or write down the card information and provide it your patient. Your patient should provide this information to the pharmacist filling his or her Takeda Oncology prescription. Using this card your patient may pay as little as $0 per prescription, up to $20,000 a year.</b></p>
              <Card cardId={ this.props.cardId } groupId={ this.props.groupId } className={ `track track-174 track-env-${this.props.environment}` }/>
              <Footnotes footnotes={ [2, 3, 4] }/>
              <CallToAction id={ 6 }/>
            </div>
          );
        })();
        break;
      case 'notElegible':
        content = (() => {
          return (
            <div className="not-eligible">
              <Header as="h1">
                  Thank you for your request
              </Header>
              <div className="red-box error">
                <p>The information you provided <b>does not match</b> our records.</p>
              </div>
              <CallToAction id={ 5 }/>
            </div>
          );
        })();
        break;
      default:
        content = <UnexpectedError code={ this.props.code } />;
    }

    return (
      <div className="sign-up full-width replace finish">
        <div className="top-bar"></div>
        <div className="wrapper">
          { content }
        </div>
      </div>
    );
  }
}

Finish.propTypes = {
  environment: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  cardId: PropTypes.string,
  groupId: PropTypes.string,
  clearForm: PropTypes.func.isRequired,
};

export default Finish;
